import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CourseTypeFormValues } from 'src/models/CourseType.model';
import CourseType from '../Layouts/CourseType';
import { useAddCourseTypeMutation } from 'src/services/CourseTypeService';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddCourseTypeWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: CourseTypeFormValues = {
    courseType: '',
  };

  const [addCourseType] = useAddCourseTypeMutation()
  // Validation Schema
  const validationSchema = object().shape({
    courseType: string().required('Please enter course type'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CourseTypeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CourseTypeFormValues>
  ) => {
    addCourseType(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm()
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CourseType formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCourseTypeWrapper;